module.exports = __webpack_public_path__ + "media/wellve.635b1f41.mp4";